module.exports = __webpack_public_path__ + "img/sma_home_top.3a59e26f.png";